import { Window } from '@progress/kendo-react-dialogs';
import React, { useEffect, useRef, useState } from 'react'
import { IChatProps } from '../types/IChatProps';
import './Chat.scss'
import { ChatApi } from '../redux/api/ChatApi';
import { useNavigate, useParams } from 'react-router-dom';
import ChatHeader from './ChatHeader';
import { TextArea } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { Hint } from "@progress/kendo-react-labels";
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { RequestChat, SetRequesting } from '../redux/reducers/ChatSlice';
import ChatDialog from './ChatDialog';
import { PartialSpinny } from './Common/Spinny';
import ChatCount from './ChatCount';
import ChatNotification from './ChatNotification';
import NewMessageSound from './NewMessageSound';

export default function ChatRequest(props: IChatProps) {
    const max = 2000;
    const dispatch = useReduxDispatch();
    const isRequesting = useReduxSelector(s => s.chat.requestingChat)
    const isChatAvailable = useReduxSelector(s => s.chat.chatAvailable)
    const { data: myChats } = ChatApi.useGetChatsQuery();
    const { data: chatConfig } = ChatApi.useGetConfigQuery();
    const { data: userProfile } = ChatApi.useGetProfileQuery();
    const navigate = useNavigate();
    const [value, setValue] = React.useState<string>('');
    const [stage, setStage] = React.useState("MINIMIZED"); //MINIMIZED
    const [leaveChat] = ChatApi.useLeaveChatMutation();
    //Check for existing chats
    const { data: existingChat } = ChatApi.useGetChatForUserQuery(userProfile?.Id, { skip: !userProfile?.Id });

    //expand the chat if there is an existing request
    const myOpenChat = myChats?.find(c => !c.IsClosed && !c.EndUser_Left)
    useEffect(() => {
        if (myOpenChat) {
            console.log('reset the for if an active chat is found');

            //reset the for if an active chat is found 
            setStage('MINIMIZED')
            setValue('');
        }

    }, [myOpenChat])

    //Send the chat request to the server
    const sendRequest = async () => {
        dispatch(SetRequesting(true));
        await dispatch(RequestChat(value));

        //reset form.
        // setStage('MINIMIZED');
        // setValue('');
    }

    //const chatProps = { EndUser_Header: "Live Chat", Staff_Image_Path: chatConfig?.Chat_Image } as IChat
    //onClick={() => setStage('DEFAULT')}
    const windowTitle = (<ChatHeader conversationUid={existingChat?.ConversationId} uId={null} image={chatConfig?.Chat_Image || './images/Host_Images/Chat/Logo.png'} header='Live Chat' onClick={() => setStage('DEFAULT')} />)
    const windowStyle = { background: `linear-gradient(to bottom, ${userProfile?.Nav_Hex_Color}, #ffffff)` };
    const parent = useRef();

    if (!userProfile)
        return <></>

    return (
        <div ref={parent} className='chat-request-wrapper'>
            <NewMessageSound />
            {existingChat
                ? <ChatDialog anchor={parent.current} id={existingChat.ConversationId} />
                : isChatAvailable &&
                <Window appendTo={parent.current} closeButton={() => <></>} style={windowStyle} title={windowTitle} width={stage == 'DEFAULT' ? 400 : 250} height={300} className='chat-request chat-window' onStageChange={(e) => setStage(e.state)} stage={stage}
                    onClose={() => navigate(-1)}
                >
                    {existingChat && !existingChat.StaffContact_Id && false && <PartialSpinny />}
                    <p className='intro' >Please enter your request in the field below and a support technician will be with you shortly</p>
                    {/* style={{ backgroundColor: shadeColor(userProfile?.Nav_Hex_Color, 20) }} */}
                    <TextArea autoFocus style={{ width: 400, maxHeight: 500 }} autoSize={false} rows={5} maxLength={max}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                    <Hint direction={"end"}>
                        {value.length} / {max}
                    </Hint>
                    <div className="k-form-buttons k-justify-content-end">
                        <Button disabled={isRequesting || !value} size='large' themeColor={"primary"} onClick={sendRequest}>Send</Button>
                    </div>
                    {isRequesting && <PartialSpinny zIndex="100" />}
                </Window>
            }
        </div>
    )
}
